import {
  AuthPageProps,
  Button,
  colors,
  Form,
  FormErrors,
  radius,
  useToast,
  Text,
} from '../../index.js'
import { AuthContainer } from './AuthContainer.js'

export const EmailPasswordLogin = ({
  appName,
  onSubmit,
  onCreateAccount,
}: Omit<AuthPageProps, 'type' | 'onResend'>) => {
  const toast = useToast()

  return (
    <AuthContainer title="Login to your account" subtitle={appName}>
      <Form
        fields={{
          email: {
            type: 'text',
            label: 'Email',
            placeholder: 'Add your email',
          },
          password: {
            type: 'text',
            inputType: 'password',
            label: 'Password',
            placeholder: 'Add your password',
          },
        }}
        onSubmit={async (values) => {
          // TODO: validate email
          const email = values['email'] as string
          const password = values['password'] as string
          return onSubmit?.({ email, password })
        }}
        validate={(values) => {
          const errors: FormErrors = {}
          if (!values?.email) {
            errors['email'] = 'Enter a valid email address.'
          }
          if (!values?.password) {
            errors['password'] = 'Enter a password.'
          }

          return errors
        }}
      >
        {({ submitForm, isSubmitting, isDisabledFromOutside }) => (
          <>
            <div style={{ padding: '0 6px', width: '100%' }}>
              <Form.Fields />
            </div>
            <div style={{ padding: '0 6px' }}>
              <Button
                keyHintVisibility="none"
                keyHint="Enter"
                variant="fill"
                trailIcon="arrow-right"
                loading={isSubmitting}
                onClick={async () => {
                  await submitForm()
                }}
              >
                Login
              </Button>
            </div>
          </>
        )}
      </Form>
      {onCreateAccount && (
        <>
          <div
            style={{
              background: colors.neutral10,
              height: 1,
              width: '100%',
            }}
          />
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
              alignItems: 'flex-start',
            }}
          >
            <div style={{ padding: '0 6px' }}>
              <Text variant="subtext-medium" color="neutral60">
                Don't have an account yet?
              </Text>
            </div>
            <Button
              size="small"
              variant="ghost"
              trailIcon="arrow-right"
              onClick={onCreateAccount}
            >
              Create account
            </Button>
          </div>
        </>
      )}
    </AuthContainer>
  )
}
